import React from 'react';
import ContentContainer from '../ContentContainer/ContentContainer';
import PFSContactCta from '../PFSContactCta/PFSContactCta';
import PFSServiceHeader from '../PFSServiceHeader/PFSServiceHeader';
import PFSServicePoints from '../PFSServicePoints/PFSServicePoints';
import PFSWhyChoosePFS from '../PFSWhyChoosePFS/PFSWhyChoosePFS';
import globalStyles from '../../styles/global.module.css';
import PFSMeetTheTeam from '../PFSMeetTheTeam/PFSMeetTheTeam';

import calculatorImage from './calculator.jpg'
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { WhatWeDoBreadcrumb } from '../PFSWhatWeDoIndex/PFSWhatWeDoIndex';
import { useLocation } from 'react-router-dom';

const PFSWhatWeDoFinOps = () => {
  const { pathname } = useLocation();

  useBreadcrumb([ WhatWeDoBreadcrumb, {
    label: "Financial Operations",
    url: pathname
  } ]);

  return (
    <div
      data-testid='PFSWhatWeDoFinOps'
    >
      <ContentContainer>
        <PFSServiceHeader title='Solving for the Modern Nonprofit.' subtitle='Financial Operations' />
        <div className={globalStyles.IntroContainer}>
          <img alt='A calculator' src={calculatorImage} className={globalStyles.IntroImage} />
          <div className={globalStyles.IntroText}>
            <p>At PFS Global, we understand that managing the financial operations of a non-profit organization can be complex and demanding. That’s why our FinOps team offers expert services tailored to your unique compliance and funding needs. By optimizing your financial management systems effectively, we provide the tools and insights necessary to ensure transparency, maximize your budget, and support your organization's long-term success.</p>
            <p>With PFS Global, you can trust that your financial operations and stewardship are in expert hands, freeing you to focus on what you do best: driving your mission forward. Contact us today to discover how we can support your financial goals.</p>
          </div>
        </div>
        <PFSServicePoints
          title='Bookkeeping - Income Tax Cash Basis'
          points={[
            'Functional Expense Allocation: Program Services, Management & General, and Fundraising',
            'Fund Accounting: Unrestricted & Restricted Funds',
            'Data Entry and Reconciliation of Bank, Credit Card, and Loan Accounts',
            'Month-End Closing of Books',
            'Monthly Management Reports',
            '1099/1042 Processing',
          ]}
        />
        <PFSServicePoints
          title='Bookkeeping - Income Tax Accrual Basis (The Above Plus)'
          points={[
            'Grant Management: Unconditional & Unrestricted, Unconditional & Restricted, and Conditional',
            'Accounts Payables',
            'Accounts Receivables',
            'Prepaid Expenses',
            'Accrued Expenses',
            'Deferred Expenses',
          ]}
        />
        <PFSServicePoints
          title='Bookkeeping - Generally Accepted Accounting Principles Basis (The Above Plus)'
          points={[
            'Asset Management',
            'Liability Management',
            'Revenue Recognition',
            'Leasing Standards',
            'Current Expected Credit Loss',
            'Assurance Readiness: Audits, Reviews, Compilations',
          ]}
        />

        <PFSServicePoints
          title='Financial Planning and Analysis (Added to the Above)'
          points={[
            'Customized Financial Packages: for Management, Executives, and Board',
            'KPI Dashboards',
            'Financial Strategy Meetings',
            'Budget Development',
            'Forecasting: for Growth and Recession',
            'Cash Flow Forecasting',
            'Cost Reductions Analysis',
          ]}
        />
      </ContentContainer>
      <PFSWhyChoosePFS />
      <PFSMeetTheTeam department='FinOps' />
      <br />
      <br />
      <br />
      <br />
      <br />
      <PFSContactCta ctaText='Call us today!' />
    </div>
  )
};

PFSWhatWeDoFinOps.propTypes = {};

export default PFSWhatWeDoFinOps;
